import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=87860086&scoped=true"
import script from "./thumbnail.vue?vue&type=script&lang=js"
export * from "./thumbnail.vue?vue&type=script&lang=js"
import style0 from "./thumbnail.vue?vue&type=style&index=0&id=87860086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87860086",
  null
  
)

export default component.exports